<template>
  <section  class="app-main">
          <!-- 商品列表 -->
    <el-card shadow="hover" style="margin-top:20px;">
      <el-table
        :data="tableData"
        @selection-change="tableChange"
        height="650"
        style="width: 100%;"
      >
        <el-table-column prop="created_at" label="添加时间" align="center">
        </el-table-column>
        <el-table-column
          prop="zh_name"
          label="中文标题"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="en_name"
          label="英文标题"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="link_zh"
          label="中文链接"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-link
              type="primary"
              v-if="scope.row.link_zh != '' && scope.row.link_zh != null"
              >{{ scope.row.link_zh }}</el-link
            >
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="link_en"
          label="英文链接"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-link
              type="primary"
              v-if="scope.row.link_en != '' && scope.row.link_en != null"
              >{{ scope.row.link_en }}</el-link
            >
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="content_zh" label="中文推送内容" align="center">
          <template slot-scope="scope">
            <span class="sendContent">{{ scope.row.content_zh }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="content_en" label="英文推送内容" align="center">
          <template slot-scope="scope">
            <span class="sendContent">{{ scope.row.content_en }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_amount" label="详情" align="center">
          <template slot-scope="scope">
            <el-button
              @click="showDetail(scope.row)"
              type="danger"
              plain
              size="mini"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
            <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>

    <!-- 展开商品详情弹框 -->
    <el-dialog
      title="站内信消息历史详情"
      :visible.sync="detail_modal"
      :close-on-click-modal="false"
      center
      width="1000px"
    >
      <el-card class="m-bottom-2">
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height">
            添加时间：{{ detail.created_at }}
          </el-col>
          <el-col :span="12" class="row-height">
            推送人员：<span v-if="detail.status == 1">未下单用户</span>
            <span v-if="detail.status == 2">下单用户</span>
            <span v-if="detail.status == 3">全部用户</span>
            <span v-if="detail.status == 4">指定用户</span>
          </el-col>
        </el-row>
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >中文标题：<span>{{ detail.zh_name }}</span>
          </el-col>
          <el-col :span="12" class="row-height"
            >英文标题：<span>{{ detail.en_name }}</span>
          </el-col>
        </el-row>
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >中文链接：<el-link
              type="primary"
              v-if="detail.link_zh != '' && detail.link_zh != null"
              >{{ detail.link_zh }}</el-link
            >
            <span v-else>无</span></el-col
          >
          <el-col :span="12" class="row-height"
            >英文链接：<el-link
              type="primary"
              v-if="detail.link_en != '' && detail.link_en != null"
              >{{ detail.link_en }}</el-link
            >
            <span v-else>无</span></el-col
          >
        </el-row>
        <div class="textarea showTextarea">
          <div class="msgEdit">
            <p>中文端推送内容</p>
            <el-input
              type="textarea"
              placeholder="请输入中文端消息通知内容"
              v-model="detail.content_zh"
              :rows="8"
              readonly
              show-word-limit
              autocomplete="off"
            >
            </el-input>
          </div>
          <div class="msgEdit">
            <p>英文端推送内容</p>
            <el-input
              type="textarea"
              v-model="detail.content_en"
              readonly
              :rows="8"
              show-word-limit
              autocomplete="off"
            >
            </el-input>
          </div>
        </div>
      </el-card>
    </el-dialog>
  </section>
</template>

<script>
import { push_list } from "@/api/market.js";
export default {
    data() {
        return {
             total: 0,
      page: 1,
      size: 10,
      tableData: [],
      detail: {},
      detail_modal: false,
        }
    },
    methods: {
            getData() {
      let params = {
        flag: 2,
      };
      push_list(params)
        .then((res) => {
          if (res.code == 20000) {
            this.tableData = res.data.data;
            this.size = res.data.per_page;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    reloadData(page) {
      this.page = page;
      this.getData();
    },
    showDetail(row) {
      this.detail = row;
      this.detail_modal = true;
    },
    },
      created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
}
</script>

<style scoped lang="less">
section {
  .checked {
    border: 1px solid #00dc41;
  }
  height: calc(100% - 60px);
  .title {
    font-size: 18px;
    color: #141414;
    line-height: 60px;
    letter-spacing: 0.4px;
    text-align: left;
  }
  .mbTip {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
    background-color: #ffebdb;
    border: 2px solid #ffbe89;
    font-size: 14px;
    line-height: 23px;
    margin: 14px 0 15px 0;
    color: #666;
  }
  .showTextarea {
    width: 100% !important;
    .msgEdit {
      width: 48%;
    }
  }
  .textarea {
    width: 85%;
    display: flex;
    min-height: 280px;
    justify-content: space-between;
    .msgEdit {
      // width: 100%;
      height: 200px;
      position: relative;
      .emjioBox {
        position: absolute;
        top: -90px;
        width: 688px;
        height: 180px;
        border: 1px solid #e1e1e1;
        background-color: #fff;
        z-index: 999;
        .emjioMain {
          width: calc(100% - 160px);
          height: 140px;
          padding: 20px;
          box-sizing: border-box;
          overflow-y: auto;
          position: relative;
          span {
            width: 35px;
            height: 35px;
            display: inline-block;
            font-size: 23px;
            cursor: pointer;
            border: 1px solid transparent;
            line-height: 35px;
            text-align: center;
            margin: 0 2px 2px 0;
            transition: all 0.5s;
            &:hover {
              border-color: darkcyan;
            }
          }
        }
        .viewEmjio {
          position: absolute;
          right: 0;
          top: 0px;
          width: 160px;
          height: 140px;
          border-left: 1px solid #e1e1e1;
          line-height: 140px;
          text-align: center;
          font-size: 80px;
        }
        .emjioList {
          width: 100%;
          height: 40px;
          background-color: #f1f1f1;
          span {
            display: inline-block;
            width: 43px;
            height: 100%;
            text-align: center;
            line-height: 40px;
            font-size: 12px;
            color: #555;
            transition: all 0.5s;
            &:hover {
              background-color: #e1e1e1;
              cursor: pointer;
            }
          }
        }
      }
      .msgTools {
        width: 100%;
        height: 35px;
        span {
          display: inline-block;
          margin-top: 8px;
          margin-right: 5px;
          font-size: 20px;
          width: 25px;
          height: 25px;
          transition: all 0.5s;
          text-align: center;
          img {
            width: 90%;
            height: 90%;
          }
        }
      }
      #msgContent,
      #msgContent2 {
        width: calc(100% - 20px);
        height: 100px;
        border: 1px solid #f1f1f1;
        padding: 10px;
        font-size: 14px;
        color: #666;
        resize: none;
      }
    }
    div {
      width: 45%;
      p {
        line-height: 42px;
        letter-spacing: 0.3px;
        font-size: 16px;
        color: #141414;
        margin-right: 20px;
      }
      /deep/ .el-textarea {
        width: 100%;
        /deep/ .el-textarea__inner {
          // 然后找到对应的类名，在这里将拉伸去掉即可
          resize: none;
        }
      }
    }
  }
  .send_person {
   /deep/ .el-radio-group {
     width: 100%;
   /deep/ .el-radio {
      margin-right: 10px;
    }
    /deep/ .el-input {
        display: inline-block;
        margin-left: 10px;
        width: 260px;
      }
  } 
  }
  

  .submit {
    width: 85%;
    margin: 10px 0 20px;
    text-align: right;
    /deep/ .el-button {
      width: 100px;
    }
  }
  .sendContent {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row-height {
    height: 40px;
    line-height: 40px;
    .row-span + .row-span {
      margin-left: 15px;
    }
    .row-total {
      margin-left: 30px;
      font-size: 16px;
      font-weight: bold;
      padding: 0 30px 10px 0;
    }
  }
}
</style>